import React from "react";
import MapImg from "../../assets/img/contact/map.webp";
const Contact = () => {
  return (
    <>
      <div className="text-center mb-4 mb-lg-5">
        <h2 className="d-inline main_heading px-3 py-2 bg_red mb-0">
          Contact us
        </h2>
      </div>
      <div
        className="open_overlay_sections_none contact-section py-5 position-relative"
        id="Contact"
      >
        <div className="position-absolute end-0 top-0 d-none d-lg-inline">
          {" "}
          <img className="  pt-5 mt-xxl-5 MapImg2 " src={MapImg} alt="" />
        </div>
        <div className="container">
          <div className="row justify-content-between mb-sm-5 mb-sm-3">
            <div
              className="col-lg-6 my-auto"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <h1 className="font-xl fw-bold    ">Address</h1>

              <a
                href=""
                className="font-lg fw-semibold black text-decoration-none opacity_07"
              >
                Luctus eleifend curabitur pretium,{" "}
                <span className="d-block opacity_07">
                  eget scelerisque interdum{" "}
                </span>
                1564546545
              </a>
            </div>
            <div
              className="col-lg-6 mt-lg-0 mt-5"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <img className="w-100   MapImg" src={MapImg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
